import { createFileRoute } from '@tanstack/react-router'
import WorkflowEditorContainer from '@/components/workflow-editor'

export const Route = createFileRoute('/_auth/automation/editor/$id')({
  component: WorkflowEditorContainerWrapper,
})

function WorkflowEditorContainerWrapper() {
  const { id } = Route.useParams()

  return <WorkflowEditorContainer id={id} />
}
